import React, { memo, useState } from "react";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { InputAdornment, Typography, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function TodayDatePicker({ label = "Date", date, setDate }) {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_COLOR = selectedClientData?.AccentColor;
  const [open, setOpen] = useState(false);

  const { TEXT_TODAY } = ClientEnglishFallback?.AddTimesheetModal(
    multiLanguageData?.AddTimesheetModal || {}
  );

  const getDisplayValue = () => {
    if (!date || !dayjs.isDayjs(date)) return "";
    
    const formattedDate = date.format("MMM DD, YYYY");
    const todayFormatted = dayjs().format("MMM DD, YYYY");
    
    return formattedDate === todayFormatted 
      ? `${formattedDate} ${TEXT_TODAY}` 
      : formattedDate;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Typography>{label}</Typography>
      
      {/* Custom display field */}
      <Box
        onClick={() => setOpen(true)}
        sx={{
          // width: "100%",
          height: "40px",
          backgroundColor: "#e4e4e4",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px",
          cursor: "pointer"
        }}
      >
        <span>{getDisplayValue()}</span>
        <InsertInvitationIcon
          sx={{
            color: CLIENT_COLOR,
            cursor: "pointer"
          }}
        />
      </Box>

      {/* Hidden DatePicker for functionality */}
      <MobileDatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={date}
        onChange={setDate}
        defaultValue={dayjs()}
        sx={{ display: "none" }} // Hide the actual picker input
      />
    </LocalizationProvider>
  );
}

export default memo(TodayDatePicker);
